import { render, staticRenderFns } from "./ReviewPage.vue?vue&type=template&id=cb5053e2&scoped=true&"
import script from "./ReviewPage.vue?vue&type=script&lang=js&"
export * from "./ReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPage.vue?vue&type=style&index=0&id=cb5053e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5053e2",
  null
  
)

export default component.exports